import{NativeModules}from'react-native';var RNCNetInfo=NativeModules.RNCNetInfo;export default RNCNetInfo;
//# sourceMappingURL=nativeModule.js.map